export default __webpack_public_path__ + "static/media/eggopenedfront.3f42f3c0.png";